import { useState, useEffect, useRef } from 'react'

import Button from '@mui/material/Button'//'react-bootstrap/Button'
import ButtonGroup from '@mui/material/ButtonGroup'//'react-bootstrap/ButtonGroup'
import { DarkButton } from '../SpiceUI/MUI'
import ResizeMarker from './ArtBoardModules/ResizeMarker';
import LayerContent from './ArtBoardModules/LayerContent';

import { IoSettingsSharp } from "react-icons/io5";
import { MdUndo } from "react-icons/md";

const pointInArtBoard = (artBoardRef, e) => {
        const rect = artBoardRef.current.getBoundingClientRect();
        const localX = e.clientX - rect.left;
        const localY = e.clientY - rect.top;
        return {x:localX, y:localY}
}

const pointInRegion = ( rect, point, pad, offset, scale ) => {
    if( point.x  < ( (rect.x) * scale - offset.x) + pad || 
        point.x  >= (( rect.x + rect.width ) * scale) - offset.x - pad )
    {
        return false;
    }

    if( point.y < ( rect.y * scale ) - offset.y + pad || 
        point.y >= (( rect.y + rect.height ) * scale - offset.y ) - pad )
    {
        return false;
    }

    return true;
}

const distanceToCenter = ( r, p, offset, scale ) => {
    let rx =( r.x  + r.width / 2) * scale - offset.x
    let ry = (r.y + r.height / 2) * scale - offset.y

    return Math.pow((p.x - rx), 2) + Math.pow((p.y - ry), 2)
}

export function ArtBoardLayer( props )
{
    const artBoardRef = props.artBoardRef
    const containerRef = props.containerRef
    const layerIdx = props.layerIdx
    const layers = props.layers;
    const layersCfg = props.layersCfg;
    const images = props.images
    const selected = props.selected;

    const update = props.update

    const selectedCoords = props.selectedCoords
    const setSelectedCoords = props.setSelectedCoords
    const manualSelectedCoords = props.manualSelectedCoords

    const zIndex = props.zIndex
    const isPointDragging = props.isPointDragging

    const globalOffset = props.globalOffset
    const artBoardOffset = props.artBoardOffset 
    const setArtBoardOffset = props.setArtBoardOffset
    const artBoardZoom = props.artBoardZoom
    
    const pointerEvent = props.pointerEvent

    const artBoardLayerRef = useRef(null)

    const [ isSelected, setIsSelected ] = useState(false)

    const offset = useRef({x:0,y:0});
    const isDragging = useRef(false)
    const [ dragging, setDragging ] = useState(false)

    const [ position, setPosition ] = useState(layersCfg.current[layers[layerIdx].id].location)
    const positionRef = useRef(null)
    const lastPositionUpdate = useRef(new Date())

    const pointerDown = useRef(false)
    const [ visibleMarker, setVisibleMarker ] = useState('all');

    const lastCoordUpdate = useRef(0);
    const COORD_THROTTLE_DELAY = 30;

    useEffect( () => {
        setPosition(layersCfg.current[layers[layerIdx].id].location )
        lastPositionUpdate.current = new Date()
    },[layers])

    const initPosition = () => {
        let layer = layers[layerIdx]

        let container = containerRef.current.getBoundingClientRect()

        let cwidth = container.width 
        let cheight = container.height

        let x = ((cwidth/2) - globalOffset.x) / artBoardZoom - artBoardOffset.x
        let y = ((cheight/2) - globalOffset.y) / artBoardZoom - artBoardOffset.y

        let pp = null

        if( layer.type == "image" )
        {
            const image = new Image();

            image.onload = function () {
                let aspect_ratio = image.width / image.height 

                let obj_width = 50 * aspect_ratio;
                let obj_height = 50;

                pp = {x:x - obj_width/2,
                    y:y - obj_height/2,
                    width: obj_width,
                    height: obj_height}
            }
            image.src = 'data:image/png;base64, ' + layer.patch
        }
        else 
        {
            let obj_width = 50;
            let obj_height = 50;

            setPosition({x:x - obj_width/2,
                y:y - obj_height/2,
                width: obj_width,
                height: obj_height})
        }

        return

    }

    useEffect( () => {
        if( selected == layers[layerIdx].id )
        {
            setIsSelected(true)

            let coords = {}
            coords.location = layersCfg.current[layers[layerIdx].id].location 
            coords.fixed_aspect_ratio = layersCfg.current[layers[layerIdx].id].fixed_aspect_ratio
            coords.is_live = false 
            setSelectedCoords(coords)

            if( pointerEvent.current && artBoardLayerRef.current  )
            {
                initDrag(pointerEvent.current)
            }
        }
        else 
        {
            setIsSelected(false)
        }
    },[selected])

    useEffect( () => {
        if( position == null )
        {
            let layer = layers[layerIdx]

            let container = containerRef.current.getBoundingClientRect()

            let cwidth = container.width 
            let cheight = container.height

            let x = ((cwidth/2) - globalOffset.x) / artBoardZoom - artBoardOffset.x
            let y = ((cheight/2) - globalOffset.y) / artBoardZoom - artBoardOffset.y

            if( layer.type == "image" )
            {
                const image = new Image();

                image.onload = function () {
                    let aspect_ratio = image.width / image.height 

                    let obj_width = 50 * aspect_ratio;
                    let obj_height = 50;

                    setPosition({x:x - obj_width/2,
                                 y:y - obj_height/2,
                                 width: obj_width,
                                 height: obj_height})
                }
                image.src = 'data:image/png;base64, ' + layer.patch
            }
            else 
            {
                    let obj_width = 50;
                    let obj_height = 50;

                    setPosition({x:x - obj_width/2,
                                 y:y - obj_height/2,
                                 width: obj_width,
                                 height: obj_height})
            }
            
            return
        }

        layersCfg.current[layers[layerIdx].id].location = position
        update()

        /*if( selected == layers[layerIdx].id )
        {
            let coords = {}
            coords.location = position 
            coords.fixed_aspect_ratio = layersCfg.current[selected].fixed_aspect_ratio
            setSelectedCoords(coords)
        }*/
    },[position])

    useEffect( () => {
        if( !isSelected )
        {
            return
        }

        if( manualSelectedCoords == null )
        {
            return
        }

        layersCfg.current[layers[layerIdx].id].location = structuredClone(manualSelectedCoords.location)
        layersCfg.current[layers[layerIdx].id].fixed_aspect_ratio = structuredClone(manualSelectedCoords.fixed_aspect_ratio)

        setPosition(manualSelectedCoords.location)

        update()

    },[manualSelectedCoords] )

    useEffect( () => {
        if( isSelected )
        {
            //setSelectedPosition( position )
        }
    },[ isSelected ])

    const initDrag = (e) => {
        const rect = artBoardRef.current.getBoundingClientRect();
        offset.current = {x:position.x * artBoardZoom - (e.clientX - artBoardOffset.x - rect.left ), 
                          y: position.y * artBoardZoom -(e.clientY - artBoardOffset.y - rect.top )}

        isPointDragging.current = true;
        pointerDown.current = true

        
    }

    const onPointerDown = (e) => {
        isDragging.current = true;
        initDrag(e)
        setDragging(true)

        positionRef.current = position


        e.currentTarget.setPointerCapture?.(e.pointerId);
        e.preventDefault();
    }

    const updateLivePosition = ( pos, is_live ) => {
        if(artBoardLayerRef.current) 
        {
            artBoardLayerRef.current.style.transform = `translate(${pos.x}px, ${pos.y}px)`;

            artBoardLayerRef.current.style.height = `${pos.height}px`
            artBoardLayerRef.current.style.width = `${pos.width}px`

            if( selected == layers[layerIdx].id )
            {
                const coords = {
                    location: pos,
                    fixed_aspect_ratio: layersCfg.current[layers[layerIdx].id]?.fixed_aspect_ratio ?? false,
                    is_live: is_live
                };

                const now = Date.now();
                const elapsed = now - lastCoordUpdate.current;

                if( elapsed > COORD_THROTTLE_DELAY )
                {
                    lastCoordUpdate.current = now 
                    setSelectedCoords(coords);
                }
            }
        }

    }

    const onPointerMove = (e) => {
        if( selected != layers[layerIdx].id )
        {
            return
        }

        if( pointerEvent.current == null )
        {
            if (!e.currentTarget.hasPointerCapture?.(e.pointerId)) return;
        }

        const rect = artBoardRef.current.getBoundingClientRect();
        const of = offset.current
        var p = { x:(e.clientX - artBoardOffset.x - rect.left) + of.x, 
                  y:(e.clientY - artBoardOffset.y - rect.top) + of.y };

        if( positionRef.current != null )
        {

            //let pos = structuredClone(position)
            let pos = positionRef.current
            pos.x = p.x / artBoardZoom 
            pos.y = p.y / artBoardZoom

            updateLivePosition(pos, true)

            positionRef.current = pos

            /*let coords = {}
            coords.location = pos  
            coords.fixed_aspect_ratio = layersCfg.current[layers[layerIdx].id].fixed_aspect_ratio
            coords.is_live = true
            //console.log(coords)
            setSelectedCoords(coords)*/
        }

        //setPosition(pos)

    }

    const onPointerUp = (e) => {
        if (e.currentTarget.hasPointerCapture?.(e.pointerId)) {
            e.currentTarget.releasePointerCapture(e.pointerId);

            isPointDragging.current = false;
            pointerDown.current = false
            isDragging.current = false

            const rect = artBoardRef.current.getBoundingClientRect();
            const of = offset.current

            var p = { x:(e.clientX - artBoardOffset.x - rect.left) + of.x, 
                      y:(e.clientY - artBoardOffset.y - rect.top) + of.y };

            //let pos = structuredClone(position)

            if( positionRef.current != null )
            {
                let pos = positionRef.current

                pos.x = p.x / artBoardZoom 
                pos.y = p.y / artBoardZoom

                // Sync final position to state once
                //
                updateLivePosition( pos, false )
                setPosition(structuredClone(pos))

            }
            pointerEvent.current = null

            positionRef.current = null
        }
        setDragging(false)
    }

    if( position == null )
    {
        return <></>
    }

    return (
        <> {/* isSelected &&
            <div style={{ position:'absolute',
                          top: artBoardOffset.y,
                          left: artBoardOffset.x,
                          transform: `translate(${position.x}px, ${position.y}px)`,
                          height: position.height, 
                          width: position.width,
                          border:(isSelected) ? "1px dashed #0077B6" : "none",
                          pointerEvents: 'none',
                          zIndex: 500,
                          overflow: 'hidden',
                          pointerEvents: 'none',
                          padding:'0.1px'
            }}
            >
                <div style={{ height:'100%', width:'100%', border:(isSelected) ? "1px dashed #FFFFFF" : "none"}}>
                </div>
            </div>
            */}
            
            <div className="user-select-none"
                 ref={artBoardLayerRef}
                 style={{ position:'absolute',
                          top: artBoardOffset.y,
                          left: artBoardOffset.x,
                          transform: `translate(${position.x}px, ${position.y}px)`,
                          height: position.height, 
                          width: position.width,
                          border: (isSelected) ? "1px dashed #0077B6" : "1px dashed #d7d7d7",
                          pointerEvents: (selected == layers[layerIdx].id) ? 'auto' : 'none',
                          zIndex: zIndex,
                          overflow: 'hidden',
            }}

                onPointerDown={onPointerDown}
                onPointerMove={onPointerMove}
                onPointerUp={onPointerUp}
            >
                <LayerContent layers={layers}
                              layerIdx={layerIdx}
                              layersCfg={layersCfg}
                />
            </div>
            { ( isSelected && !dragging) && 
            <>
                <ResizeMarker loc="TL"
                              artBoardRef={artBoardRef}
                              position={position}
                              setPosition={setPosition}
                              positionRef={positionRef}
                              updateLivePosition={updateLivePosition}         
                              fixedAspectRatio={layersCfg.current[layers[layerIdx].id].fixed_aspect_ratio}
                              isPointDragging={isPointDragging}
                              artBoardOffset={artBoardOffset}
                              artBoardZoom={artBoardZoom}
                              visibleMarker={visibleMarker}
                              setVisibleMarker={setVisibleMarker} 
                />
                <ResizeMarker loc="TR"
                              artBoardRef={artBoardRef}
                              position={position}
                              setPosition={setPosition}
                              positionRef={positionRef}
                              updateLivePosition={updateLivePosition}
                              fixedAspectRatio={layersCfg.current[layers[layerIdx].id].fixed_aspect_ratio}
                              isPointDragging={isPointDragging}
                              artBoardOffset={artBoardOffset}
                              artBoardZoom={artBoardZoom}
                              visibleMarker={visibleMarker}
                              setVisibleMarker={setVisibleMarker} 
                />
                <ResizeMarker loc="BL"
                              artBoardRef={artBoardRef}
                              position={position}
                              setPosition={setPosition}
                              positionRef={positionRef}
                              updateLivePosition={updateLivePosition}
                              fixedAspectRatio={layersCfg.current[layers[layerIdx].id].fixed_aspect_ratio}
                              isPointDragging={isPointDragging}
                              artBoardOffset={artBoardOffset}
                              artBoardZoom={artBoardZoom}
                              visibleMarker={visibleMarker}
                              setVisibleMarker={setVisibleMarker} 
                />
                <ResizeMarker loc="BR"
                              artBoardRef={artBoardRef}
                              position={position}
                              setPosition={setPosition}
                              positionRef={positionRef}
                              updateLivePosition={updateLivePosition}
                              fixedAspectRatio={layersCfg.current[layers[layerIdx].id].fixed_aspect_ratio}
                              isPointDragging={isPointDragging}
                              artBoardOffset={artBoardOffset}
                              artBoardZoom={artBoardZoom}
                              visibleMarker={visibleMarker}
                              setVisibleMarker={setVisibleMarker} 
                />
            </> 
            }
        </>
    )
}

export function ArtBoardSnapshot( props )
{
    const layers = props.layers 
    const images = props.images 
    const layersCfg = props.layersCfg

    const artBoardRef = useRef(null)
    const [ artBoardOffset, setArtBoardOffset ] = useState({x:0,y:0})

    const update = () => {
    }

    return (
        <div ref={artBoardRef} 
            style={{ width:'100%', height:'100%', position:'relative'}}
                    >
            {layers.map( (layer,idx) => 
            <ArtBoardLayer artBoardRef={artBoardRef}
                           layerIdx={idx}
                           layers={layers} 
                           layersCfg={layersCfg} 
                           artBoardOffset={artBoardOffset}
                           setArtBoardOffset={setArtBoardOffset}
                           update={update}
                           zIndex={layers.length - idx}
            />)}

        </div>
    )

}

const MIN_ZOOM = 0.1;
const MAX_ZOOM = 2;
const ZOOM_SPEED = 1.015;

const clamp = (value, min, max) => {
     return Math.min(max, Math.max(min, value));
}


export default function ArtBoard( props )
{
    const layers = props.layers 
    const images = props.images 
    const layersCfg = props.layersCfg
    const selected = props.selected 
    const setSelected = props.setSelected
    const selectedIdx = props.selectedIdx 
    const setSelectedIdx = props.setSelectedIdx

    const reEval = props.reEval
    const setReEval = props.setReEval

    const selectedCoords = props.selectedCoords
    const setSelectedCoords = props.setSelectedCoords
    const manualSelectedCoords = props.manualSelectedCoords

    const isPointDragging = props.isPointDragging
    const undo = props.undo

    const widgetName = props.widgetName
    const onWidgetName = props.onWidgetName

    const containerRef = useRef(null)
    const artBoardRef = useRef(null)
    const initialized = useRef(false)

    const [ globalOffset, setGlobalOffset ] = useState({x:-1500,y:-1500})
    const [ artBoardOffsetLayers, setArtBoardOffsetLayers ] = useState({x:0,y:0})

    const [ artBoardZoom, setArtBoardZoom ] = useState(1.0)

    const selectedRef = useRef("")
    const pointerEvent = useRef(null)

    const keyDownListener = (e) => {

        if ((e.ctrlKey || e.metaKey) && e.key == "z") {
            undo()
            e.preventDefault()
        }
    }

    const moveLayersToArtBoardCenter = () => {
        var x0 = 3000 
        var y0 = 3000 
        var x1 = 0 
        var y1 = 0 

        for( const layer of layers )
        {
            const layer_cfg = layersCfg.current[layer.id]
            const location = layer_cfg.location

            if( location == null )
            {
                continue
            }

            if( location.x < x0 )
            {
                x0 = location.x
            }

            if( location.y < y0 )
            {
                y0 = location.y 
            }

            if( location.x + location.width >= x1 )
            {
                x1 = location.x + location.width 
            }

            if( location.y + location.height >= y1 )
            {
                y1 = location.y + location.height
            }
        }

        const x_mid = (x1 - x0)/2
        const y_mid = (y1 - y0)/2

        const o = {x:1500+x0,y:1500+y0 }
        setArtBoardOffsetLayers({x:1500-x0-x_mid, y:1500-y0-y_mid})
    }

    useEffect(() => {
        //moveLayersToArtBoardCenter()
        //
        
        let cheight = containerRef.current.clientHeight 
        let cwidth = containerRef.current.clientWidth

        setGlobalOffset({x:-1500 + cwidth/2,y:-1500 + cheight/2})

        window.addEventListener("keydown", keyDownListener)
        return () => {
            window.removeEventListener("keydown", keyDownListener)
        }
    },[])

    useEffect(() => {
        if( layers.length == 0 )
        {
            return
        }
            
        if( initialized.current )
        {
            return
        }

        moveLayersToArtBoardCenter()

        initialized.current = true
    },[layers])

    const clickSelection = (p) => {
        // Iterate backwards starting from the top-most layer
        for (let idx = 0; idx < layers.length; idx++) {
            const layer = layers[idx];
            const location = layersCfg.current[layer.id]?.location;

            if (!location) continue;

            // The moment we find a layer the mouse is hovering over, we select it!
            if (pointInRegion(location, p, 0, globalOffset, artBoardZoom)) {
                return { idx, id: layer.id }; 
            }
        }

        // Return default if nothing is clicked
        return { idx: -1, id: "" }; 
    };

    const resizeMarkerSelected = (location,point) => { 
        if( location == null )
        {
            return false;
        }

        let r = null

        // Top Left
        r = {x:location.x - 5, 
            y:location.y - 5,
            width: 10,
            height: 10
        }

        if( pointInRegion(r,point,0, globalOffset, artBoardZoom) )
        {
            return true;
        }

        // Top Right
        r = {x:location.x + location.width - 5, 
            y:location.y - 5,
            width: 10,
            height: 10
        }

        if( pointInRegion(r,point,0, globalOffset, artBoardZoom) )
        {
            return true;
        }

        // Borrom Left
        r = {x:location.x - 5, 
            y:location.y + location.height - 5,
            width: 10,
            height: 10
        }

        if( pointInRegion(r,point,0, globalOffset, artBoardZoom) )
        {
            return true;
        }

        // Bottom Right
        r = {x:location.x + location.width - 5, 
            y:location.y + location.height - 5,
            width: 10,
            height: 10
        }

        if( pointInRegion(r,point,0, globalOffset, artBoardZoom) )
        {
            return true;
        }

        return false;
    }

    const onPointerDown = (e) => {
        e.preventDefault()

        let point = pointInArtBoard(artBoardRef, e)

        point.x -= globalOffset.x + artBoardOffsetLayers.x * artBoardZoom 
        point.y -= globalOffset.y + artBoardOffsetLayers.y * artBoardZoom


        if( selected && layersCfg.current[selected] != null )
        {

            if( resizeMarkerSelected(layersCfg.current[selected].location, point) )
            {
                return 
            }
        }

        let selection_data = clickSelection(point);

        setSelected(selection_data.id)
        setSelectedIdx(selection_data.idx)

        selectedRef.current = selection_data.id 

        if( selectedRef.current != "" )
        {
            //e.currentTarget.setPointerCapture?.(e.pointerId);
            //e.preventDefault();

            pointerEvent.current = {clientX:e.clientX, clientY:e.clientY, pointerId:e.pointerId} 
            return
        }

        e.currentTarget.setPointerCapture?.(e.pointerId);
        e.preventDefault();
    }

    const onPointerMove = (e) => {
        e.preventDefault()
        if( selectedRef.current != "" )
        {
            return
        }

        if (!e.currentTarget.hasPointerCapture?.(e.pointerId)) return;

        const rect = artBoardRef.current.getBoundingClientRect();

        let of = structuredClone(globalOffset)

        of.x += e.movementX 
        of.y += e.movementY

        //of.x = clamp( of.x, -5000, 0 )
        //of.y = clamp( of.y, -5000, 0 )

        setGlobalOffset(of)
    }

    const onPointerUp = (e) => {
        e.preventDefault()
        /*if( selectedRef.current != "" )
        {
            return
        }*/

        if (e.currentTarget.hasPointerCapture?.(e.pointerId)) {
            e.currentTarget.releasePointerCapture(e.pointerId);
        }
        pointerEvent.current = null
    }

    const update = () => {
        let e = parseInt(reEval) + 1 
        setReEval(e)
    }

    const zoomIn = () => {
        setArtBoardZoom( clamp( artBoardZoom * 1.1, MIN_ZOOM, MAX_ZOOM) )
    }

    const resetZoom = () => {
        setArtBoardZoom( 1.0 )
    }

    const zoomOut = () => {
        setArtBoardZoom( clamp( artBoardZoom * 0.9, MIN_ZOOM, MAX_ZOOM) )
    }

    useEffect(() => {
        const handleWheel = (e) => {
            if (artBoardRef.current && artBoardRef.current.contains(e.target)) {
                e.preventDefault();
                e.stopPropagation();

                const rect = artBoardRef.current?.getBoundingClientRect();
                if (!rect) return;

                const mouseX = e.clientX - rect.left;
                const mouseY = e.clientY - rect.top;

                const zoomFactor = e.deltaY < 0 ? ZOOM_SPEED : 1 / ZOOM_SPEED;
                const newZoom = clamp(artBoardZoom * zoomFactor, MIN_ZOOM, MAX_ZOOM);

                if (newZoom === artBoardZoom) return;

                const x_disp = mouseX - mouseX * zoomFactor;
                const y_disp = mouseY - mouseY * zoomFactor;

                const newOffsetX = globalOffset.x + x_disp;
                const newOffsetY = globalOffset.y + y_disp;

                setArtBoardZoom(newZoom);
                setGlobalOffset({ x: newOffsetX, y: newOffsetY });
            }
        };

        document.addEventListener('wheel', handleWheel, { passive: false });
        return () => {
            document.removeEventListener('wheel', handleWheel);
        };
    }, [artBoardZoom, globalOffset, artBoardRef, setArtBoardZoom, setGlobalOffset]);

    return (
        <div className="user-callout-none"
             ref={containerRef}
             style={{ width:'100%',
                      height:'100%', 
                      position:'relative',
                      overflow:'hidden',
                      }}
        >
        <div ref={artBoardRef} 
             style={{ width:'3000px', 
                     height:'3000px', 
                     position:'absolute',
                     overflow:'hidden', 
                     cursor:'crosshair',
                     transformOrigin: "0 0",
                     left: globalOffset.x,
                     top: globalOffset.y,
                     transform: `scale(${artBoardZoom})`,
                     backgroundImage: `
                        linear-gradient(to right, rgba(0,0,0,0.1) 0.1px, transparent 1px),
                        linear-gradient(to bottom, rgba(0,0,0,0.1) 0.1px, transparent 1px)
                     `,
                     backgroundSize: `10px 10px`,
                     border:'solid 1px',
                     touchAction: 'none'
            }}
            onPointerDown={onPointerDown}
            onPointerMove={onPointerMove}
            onPointerUp={onPointerUp}
        >
            {layers.map( (layer,idx) => 
            <ArtBoardLayer artBoardRef={artBoardRef}
                           containerRef={containerRef}
                           layerIdx={idx}
                           layers={layers} 
                           layersCfg={layersCfg} 
                           images={images}
                           selected={selected}
                           key={idx}
                           update={update}
                           selectedCoords={selectedCoords}
                           setSelectedCoords={setSelectedCoords}
                           manualSelectedCoords={manualSelectedCoords}
                           zIndex={layers.length - idx}
                           isPointDragging={isPointDragging}
                           globalOffset={globalOffset}
                           artBoardOffset={artBoardOffsetLayers}
                           artBoardZoom={artBoardZoom}
                           setArtBoardOffset={setGlobalOffset}
                           pointerEvent={pointerEvent}
            />)}
        </div>
            <Button size="small"
                    style={{ position: 'absolute', top: '2px', left: '2px', textTransform: 'none' }}
                    onClick={onWidgetName}
                >
                    {(widgetName.current != "") ? widgetName.current : "Untitled"} <IoSettingsSharp style={{ fontSize: '12px' }} />
            </Button>

            <ButtonGroup style={{ position: 'absolute', bottom: '5px', right: '5px' }}>
                <DarkButton variant="contained" size="small" onClick={undo}>
                    <MdUndo style={{ fontSize: '25px' }} />
                </DarkButton>
            </ButtonGroup>

        </div>
    )
}
